import DateService from '../services/DateService'

class DateAvailabilityError {
    message: string
    fields: string[]

    constructor (data: any) {
        this.message = data.message
        this.fields = data.fields
    }
}

export default class DateAvailability {
    date: Date
    valid: boolean
    errors: DateAvailabilityError[] = []

    constructor(data: any) {
        this.date = DateService.formatDateFromAPI(data.date)
        this.valid = data.valid

        data.errors.forEach((error: any) => {
            this.errors.push(
                new DateAvailabilityError(error)
            )
        })
    }
}


// WEBPACK FOOTER //
// ./src/models/DateAvailability.ts